import { isRejectedWithValue, type Middleware } from "@reduxjs/toolkit";
import { bffApi } from "../../autogen/bff-api";

export const REFUSALS_FOR_AN_INACTIVE_AGREEMENT: ReadonlySet<string> = new Set([
  "zz_FrameworkAgreementApiErrorCodeFrameworkAgreementNotActive",
  "zz_FrameworkAgreementApiErrorCodeFrameworkAgreementTermEnded",
  "zz_FrameworkAgreementApiErrorCodeFrameworkAgreementTermNotStarted",
  "zz_FrameworkAgreementApiErrorCodeAwardedMiniCompetitionCanOnlyBeCancelled",
]);

const refusesForAnInactiveAgreement = (payload: unknown): boolean => {
  const errorCode = (payload as { data?: { errorCode?: unknown } } | undefined)
    ?.data?.errorCode;
  return (
    typeof errorCode === "string" &&
    REFUSALS_FOR_AN_INACTIVE_AGREEMENT.has(errorCode)
  );
};

export const refreshFrameworkAgreementsWhenRefused: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);
    if (
      isRejectedWithValue(action) &&
      refusesForAnInactiveAgreement(action.payload)
    ) {
      store.dispatch(bffApi.util.invalidateTags(["FrameworkAgreement"]));
    }
    return result;
  };
